// assets/shop-by-use.js
// Active dot for the "Shop by Use" carousel (sections/shop-by-use.liquid).
// The scrolling, snapping and alignment are pure CSS - this file only moves
// .is-active between dots that are already in the DOM, so the carousel still
// scrolls and snaps with JavaScript unavailable (dot 1 just stays active).
// The dots do not navigate, so there is no index or slide-to logic to own.
//
// This reads the scroll position rather than observing intersections. An
// IntersectionObserver only fires when a card crosses its threshold, and at
// both ends of the track the last crossing happens before the scroll stops,
// which left the first and last dots unreachable.
(function () {
  var DESKTOP = '(min-width: 1024px)';

  function init(root) {
    if (root.dataset.sbuInit) return;

    var track = root.querySelector('[data-sbu-track]');
    var dots = root.querySelector('[data-sbu-dots]');
    if (!track || !dots) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.sbu-card'));
    if (cards.length < 2) return;

    root.dataset.sbuInit = 'true';

    var mq = window.matchMedia(DESKTOP);
    var listening = false;
    var frame = null;

    // Coalesce to one recalculation per painted frame while scrolling.
    function onScroll() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        setActive(activeIndex());
      });
    }

    function setActive(index) {
      for (var i = 0; i < dots.children.length; i++) {
        dots.children[i].classList.toggle('is-active', i === index);
      }
    }

    // The card the strip is resting on, or heading to: the one whose settled
    // scroll position is nearest to where we are now. A card settles when it
    // is centred, so that is what each position is measured from, and the dot
    // hands over halfway between one card and the next.
    function activeIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var scrolled = track.scrollLeft;
      var half = track.clientWidth / 2;
      // The first and last cards never reach their own centre, because the
      // strip runs out of scroll before they get there. Clamping to the real
      // travel is what keeps the first and last dots reachable.
      var maxScroll = track.scrollWidth - track.clientWidth;
      var best = 0;
      var bestGap = Infinity;

      cards.forEach(function (card, i) {
        var rect = card.getBoundingClientRect();
        var centre = rect.left - trackLeft + scrolled + rect.width / 2;
        var rest = Math.max(0, Math.min(centre - half, maxScroll));
        var gap = Math.abs(rest - scrolled);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      });

      return best;
    }

    function connect() {
      if (listening) return;
      listening = true;
      track.addEventListener('scroll', onScroll, { passive: true });
      // Nothing has scrolled yet, so set the starting dot directly. This also
      // resyncs when rotating in from the desktop grid.
      setActive(activeIndex());
    }

    function disconnect() {
      if (!listening) return;
      listening = false;
      track.removeEventListener('scroll', onScroll);
      if (frame) {
        cancelAnimationFrame(frame);
        frame = null;
      }
    }

    function sync() {
      if (mq.matches) disconnect();
      else connect();
    }

    sync();

    if (mq.addEventListener) mq.addEventListener('change', sync);
    else mq.addListener(sync);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.sbu').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor re-renders the section, so re-init the fresh DOM.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
